import ConsultantSetting from './ConsultantSetting';

export default ConsultantSetting;
